import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';

/**
 * The browse credits of today (`browse.usage`): the meter, the reset time, the opened items and the
 * follow slots. A details page charges the credit, so the query refreshes when the user comes back:
 * on window focus, and on each mount of the Browse page (`refetchOnMount: 'always'`, because the
 * in-app move from a details page back to Browse is no window focus).
 */
export function useBrowseUsage(options?: { enabled?: boolean; refetchOnMount?: boolean | 'always' }) {
  const trpc = useTRPCAPI();
  return useTRPCQuery(
    trpc.browse.usage.queryOptions(undefined, {
      enabled: options?.enabled ?? true,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: true,
      refetchOnMount: options?.refetchOnMount ?? true,
    })
  );
}

export type BrowseUsageData = NonNullable<ReturnType<typeof useBrowseUsage>['data']>;
